import React, { useEffect, useMemo, useState } from 'react';
import './style.css';

/**
 * Tabla para marcar asistencia por estudiante.
 *
 * Props:
 * - students: array de estudiantes (de bootcamp) con { id/_id, username, email }
 * - onAttendanceChange: (rows) => void
 */
const AttendanceTable = ({ students = [], onAttendanceChange }) => {
    const initialRows = useMemo(() => {
        const list = Array.isArray(students) ? students : [];
        return list.map((s) => ({
            ...s,
            id: s?.id || s?._id,
            attended: false,
            observation: '',
        }));
    }, [students]);

    const [rows, setRows] = useState(initialRows);

    useEffect(() => {
        setRows(initialRows);
    }, [initialRows]);

    useEffect(() => {
        onAttendanceChange?.(rows);
    }, [rows, onAttendanceChange]);

    const toggleAttended = (id) => {
        setRows((prev) => prev.map((r) => (r.id === id ? { ...r, attended: !r.attended } : r)));
    };

    const setObservation = (id, value) => {
        setRows((prev) => prev.map((r) => (r.id === id ? { ...r, observation: value } : r)));
    };

    return (
        <div className="attendance-table">
            <div className="attendance-table__header">
                <div>Estudiante</div>
                <div className="attendance-table__center">Presente</div>
                <div>Observación</div>
            </div>
            <div className="attendance-table__body">
                {rows.map((r) => (
                    <div className="attendance-table__row" key={r.id || r.email}>
                        <div className="attendance-table__student">
                            <div className="attendance-table__name">{r.username || '-'}</div>
                            <div className="attendance-table__email">{r.email || '-'}</div>
                        </div>
                        <div className="attendance-table__center">
                            <input
                                type="checkbox"
                                checked={!!r.attended}
                                onChange={() => toggleAttended(r.id)}
                            />
                        </div>
                        <div>
                            <input
                                className="attendance-table__input"
                                type="text"
                                placeholder="Opcional"
                                value={r.observation || ''}
                                onChange={(e) => setObservation(r.id, e.target.value)}
                            />
                        </div>
                    </div>
                ))}
                {rows.length === 0 && (
                    <div className="attendance-table__empty">No hay estudiantes para marcar asistencia.</div>
                )}
            </div>
        </div>
    );
};

export default AttendanceTable;


